import { TableConvertedData, TableDataRow, TableHeaderData } from "./types";

export const convertDataRows = (
  tableHeaders?: TableHeaderData[],
  tableData?: TableDataRow[]
): TableConvertedData[] => {
  const convertedData = tableData?.map((item) => {
    const mapValuesToHeaders = tableHeaders?.reduce(
      (acc, header) => {
        return {
          ...acc,
          [header.key]: item.values?.[header.key]?.value ?? "N/A",
          meta: {
            className: item.className,
            valuesStyles: {
              ...acc.meta?.valuesStyles,
              [header.key]: item.values[header.key]?.styles
            }
          }
        };
      },
      { meta: { valuesStyles: {} } }
    );

    return mapValuesToHeaders;
  });

  return convertedData as TableConvertedData[];
};
